import React, { useState, useEffect } from "react";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useLocation } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";
import PurchaseView from "../../../../../entities/DashboardPage/AccountingModule/Purchase/PurchaseView";
import PurchaserOrderViewPage from "../../../../../entities/DashboardPage/AccountingModule/Purchase/PurchaseOrderView";

const PurchaseOrderView = () => {
  const [purchaseOrderData, setPurchaseOrderData] = useState({});
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const { item } = state || {};

  const handleDownload = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleDownloadPurchaseOrderInvoice(item?._id);
      if (!result) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const blob = new Blob([result], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${"pdf"}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getViewInvoice = async () => {
    const result = await AuthService.getPurchaseOrderView(item?._id);
    return { __html: result };
  };

  const handleSendPurchaseOrder = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.sentPurchaseOrder(item?._id);
      if (result?.success === true) {
        getViewInvoice();
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleMarkReceive = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.markReceive(item?._id);
      if (result?.success === true) {
        getViewInvoice();
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getOnePurchaseOrderHandler = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getOnePurchaseOrder(id);
      if (result?.success) {
        setPurchaseOrderData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }

  useState(() => {
    getOnePurchaseOrderHandler(item?._id);
  }, [])


  return (
    <PurchaserOrderViewPage handleDownload={handleDownload} handleShowPdf={getViewInvoice} handleSendPurchaseOrder={handleSendPurchaseOrder} handleMarkReceive={handleMarkReceive} purchaseOrderData={purchaseOrderData}/>
  )
}

export default PurchaseOrderView;
